<template>
  <div class="topten">
    <div v-if="selected && selected.length>0" class="rankings" >
     
      <div style="line-height:30px;">Your Ranking<span v-if="selected.length>1">s</span></div>
       <div v-for="(r,ri) in selected" :key="'r'+ri" :class="'rankBtn '+r.diff" @click="showRank(r.rank)">{{(parseInt(r.rank)+1)}}</div>
       
    </div>
    
   <div style="width:100%; overflow-x:auto;">
    <ScoreLine  :score="titles" :HR="heading" :showDifficulty="showDifficulty"></ScoreLine>
    <div class="leaderScroll" :ref="'scroller'">
    <ScoreLine  v-for="(score,si) in scores.slice(0,max)" :key="'s'+si" :showDifficulty="showDifficulty" :score="score" :index="''+(si+1)" :class="'row'+highlightRow(score,si)" :ref="'S'+si"></ScoreLine>
   </div>
   </div>
  </div>
</template>

<script>
import ScoreLine from '@/components/ScoreLine.vue'
export default {
  name: 'TopTen',
  props: {
    scores:{},
    heading:{},
    
    highlight:{
      type:String,
      required:false, 
      default:""
    },
    max:{
      type:Number,
      required:false,
      default:10000000
    },
    showDifficulty: {
            type: Boolean,
            default: false,
        },
  },
  components:{ScoreLine},
  data() {
      return {
        titles:{
          Name:"Name",
          score:"Score",
          Level:"Level",
          Difficulty:"Difficulty",
          BallsHit:"Hits",
          BallsScored:"Nets",
        },

         selected:[],
      }
  },  
  methods:{
    highlightRow(val){
   
        if(this.highlight==val.Name){
          return "Selected "+ val.Difficulty
        }else{
          return "NOT"
        }
    },
    showNext(val){

      this.selected=[]
      let found=false
      console.log("XXXScores",this.scores,this.selected.length)
      for (var s in this.scores){
        if (this.scores[s].Name==val){
          found=true
          this.selected.push({rank:s,diff:this.scores[s].Difficulty})
        }
      }
    
      if(!found){
        return
      }
      let bar= this.$refs["S"+ this.selected[0].rank]
      let barElement
      let scroller=this.$refs.scroller
      console.log(scroller.clientHeight,scroller.scrollHeight,scroller.scrollTop)
      console.log("XXXX",this.selected)
       console.log("BAR",bar)
      if(bar){
         barElement=bar[0].$el
        console.log( barElement.offsetTop-scroller.offsetTop)
       scroller.scrollTop=barElement.offsetTop-scroller.offsetTop
      }
      
    },
    showRank(val){
      let bar= this.$refs["S"+ val]
      let barElement
      let scroller=this.$refs.scroller
      console.log(scroller.clientHeight,scroller.scrollHeight,scroller.scrollTop)
       console.log(bar)
      if(bar){
         barElement=bar[0].$el
        console.log( barElement.offsetTop-scroller.offsetTop)
       scroller.scrollTop=barElement.offsetTop-scroller.offsetTop
      }
    }
  },
  watch:{
    highlight(val){
      console.log("NEW Selection",val)
      this.$nextTick(() => {
       this.showNext(val)
      });
      
    }
  }
}
  

</script>

<style scoped lang="scss">
@import "@/css/colors.scss";
  .topten{
    margin-top:0px;
    
  }
  .leaderScroll{
    height: 530px;
    overflow-y:auto;
  }
 
  .rankings{
    display:flex;
    margin:auto;
    background-color:#000;
    color:#fff;
    padding-left:54px;
    padding-bottom:20px;
  }
  .rankBtn{
    margin:5px;
    border:#000 solid 1px;
    color:#000;
    border-radius:3px;
    text-align: center;
    width:40px;
    cursor:pointer;
    
  }
</style>
